export default __webpack_public_path__ + "maps-examples-runtime-animate-line-thumbnail-960-7c7a0028898dc26e8075bae6f6c14a17.png";